/**
 * @file index.tsx
 * @fileoverview Draw circle with a percentage value.
 */

import { ColorsProps } from "../../../../theme/colors";
import styles from "./chartCircle.module.scss";

export type CirclePercentageProps = ColorsProps & {
  /**
   * The width for the percentage chart.
   *
   * @default 30%;
   */
  width?: string;
  /**
   * The actual percentage value from 0 to 100.
   */
  percentage: number;
  /**
   * Text to show inside the circle element.
   *
   * @default null
   */
  text?: string;
  /**
   * Extra class names to override styles.
   */
  className?: string;
};

/**
 * Shows a percentage little chart with a optional text inside.
 * Useful for showing information around how much something is filled in (e.g. a users profile).
 */
export const CirclePercentage = ({
  width = "30%",
  percentage,
  text,
  color = "primary",
  className = "",
  ...props
}: CirclePercentageProps) => {
  return (
    <div
      className={`
        ${className}
        ${styles.chartCircle}
      `.trim()}
      style={{ width }}
      {...props}
    >
      <svg viewBox="0 0 36 36" className={styles.circularChart}>
        <path
          className={styles.circleBg}
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className={styles.circle}
          style={{
            stroke: `var(--color-${color})`,
          }}
          strokeDasharray={`${percentage}, 100`}
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        {text && (
          <text x="18" y="20.35" className={styles.percentage}>
            {text}
          </text>
        )}
      </svg>
    </div>
  );
};
export default CirclePercentage;
